import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { errorToast, successToast } from "../../Utils/utils";


// This is for all feature pages with upvote functionality
export function loadFeatureUpvotes(){
    $(".upvote-feature").on("click", function(){
        const featureId = $(this).data("featureid");
        const btn = $(this);
        const status = $(this).hasClass("active");
        const add = (status) ? -1 : 1;
        const message = status ? 'Dein Vote wurde gelöscht' : 'Vielen Dank für deinen Vote!'

        let url = '/feature/' + featureId.toString() + '/vote';
        url += (status) ? '/down' : '/up' 

        const success = function(data){
            successToast(message, "Erfolg", 3500, true);
            const voteCount = btn.find(".vote-count");
            const prevCount = parseInt(voteCount.html());
            voteCount.html((prevCount + add).toString());
            btn.toggleClass("active");
        }

        ajaxRequest(url, success, {}, $(this));
    })
}
